import Modal from './modal';
import Cookies from './cookies';

export const cookies = new Cookies();
export const modal = new Modal();

export { observer } from 'mobx-react-lite';
